/* istanbul ignore file */

export const MAX_SUGGESTIONS = 10
export const MAX_NAVIGATIONAL_SUGGESTIONS = 1
export const SEARCH_BAR_HEIGHT_PX = '48px'
export const ICON_SIZE_PX = '24px'
export const LIST_ICON_SIZE_PX = '20px'
export const CLEAR_BUTTON_SIZE_MOBILE_PX = '44px'
export const CLEAR_BUTTON_SIZE_DESKTOP_PX = '36px'
export const SKELETON_LIST_ITEM_HEIGHT_PX = '28px'
export const DEFAULT_SEARCH_DEPARTMENT = 'all_cards'
export const DEFAULT_TAB_NAME = 'All'
export const MAX_CARD_SUGGESTIONS = 5
export const MAX_GIFT_SUGGESTIONS = 3
export const MAX_FLOWERS_AND_PLANTS_SUGGESTIONS = 3
export const MAX_ALL_SUGGESTIONS =
  MAX_CARD_SUGGESTIONS +
  MAX_GIFT_SUGGESTIONS +
  MAX_FLOWERS_AND_PLANTS_SUGGESTIONS
